<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     :btn_copy = "can_copy"
                     @copy="handleCopy"
                     :btn_add = "can_add"
                     :btn_delete="can_delete"
                     :btn_edit="can_edit"
        >
            <div class="pull-right">
                <el-radio-group v-model="search.extra_filters.expire" size="small" class="mt-1" @change="reload">
                    <el-radio-button label="未过期" ></el-radio-button>
                    <el-radio-button label="过期"></el-radio-button>
                    <el-radio-button label="全部"></el-radio-button>
                </el-radio-group>
            </div>
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel"></edit-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-account',
        components: {FrontTable, EditDialog},
        created() {
            this.model =  'Admin.' + this.$route.meta.model;
        },
        computed:{
            can_copy(){
                return this.$route.meta?this.$route.meta.copy:false;
            },
            can_add(){
                return this.$route.meta?!this.$route.meta.no_add:true
            },
            can_delete(){
                return this.$route.meta?!this.$route.meta.no_delete:true
            },
            can_edit(){
                return this.$route.meta?!this.$route.meta.no_edit:true
            }
        }
    }

</script>

<style lang="scss">

</style>
